import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { ContactForm } from '../components/_dashboard/user';
import { contactData } from '../DATA/DataText';
import GoogleMap from '../components/_dashboard/user/Map';
import Map1 from '../components/_dashboard/user/Map1';

const useStyles = makeStyles((theme) => ({
  backgroundFix1: {
    position: 'relative',
    height: '200px',
    marginTop: 80,
    width: '100%',
    background: '#f27474',
    zIndex: 2
  },
  backgroundFix: {
    position: 'relative',
    height: '400px',
    width: '100%',
    background: `url('/static/hero/hero6.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: '100% 100%',
    backgroundAttachment: 'fixed',
    zIndex: 2
  },
  centerTitleContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 0.9,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  centerTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    flexDirection: 'column',
    marginTop: '10px',
    padding: '0px 10px',
    '& h1': {
      fontSize: '40px',
      color: 'white',
      fontWeight: 500,
      lineHeight: '28px',
      fontFamily: 'Open Sans, sans-serif',
      textAlign: 'center'
    },
    '& h3': {
      fontSize: '17px',
      fontWeight: 400,
      color: 'white',
      marginTop: 15,
      fontFamily: 'Open Sans, sans-serif',
      textAlign: 'center'
    }
  },
  wraper: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
    padding: '100px 0px'
  },
  contact: {
    display: 'flex',
    justifyContent: 'center',
    padding: 20
  },
  contactInfo: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    marginTop: 30,
    '&:hover': {
      '& $description, $iconCard': {
        color: '#F78181'
      }
    }
  },
  title: {
    fontSize: '25px',
    fontFamily: 'Oregano, cursive',
    color: '#4c494a',
    fontWeight: 400,
    textTransform: 'capitalize'
  },
  description: {
    fontSize: '18px',
    fontFamily: 'Oregano, cursive',
    color: 'grey',
    textTransform: 'lowercase'
  },
  iconCard: {
    fontSize: '18px',
    margin: '0px 10px 0px 10px',
    fontFamily: 'Oregano, cursive',
    color: 'grey'
  },
  gridItem: {
    '@media (max-width:900px)': {
      marginTop: 20
    }
  }
}));

const Contact = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();
  console.log('contact==>', contactData);
  return (
    <div>
      <Grid container xs={12} className={classes.backgroundFix1}>
        <Box className={classes.centerTitleContainer}>
          <Box className={classes.centerTitle}>
            <h1>{t('nous_contacter')}</h1>
            <h3>{t('contacter_desc')}</h3>
          </Box>
        </Box>
      </Grid>
      <Grid container xs={12} className={classes.wraper}>
        <Grid container maxWidth="1024px" className={classes.contact}>
          <Grid item xs={12} md={4} className={classes.gridItem}>
            <Box className={classes.Info}>
              <Typography className={classes.title}>{t('nos_coordonnées')}</Typography>
              {contactData[0].children.map((row) => (
                <Box className={classes.contactInfo}>
                  <Icon icon={row.icon} className={classes.iconCard} />
                  <Typography className={classes.description}>{row.title}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item xs={12} md={8} className={classes.gridItem}>
            <ContactForm />
          </Grid>
        </Grid>
      </Grid>
      <Map1 />
      <Grid container xs={12} className={classes.backgroundFix} />
    </div>
  );
};

export default Contact;
